import { render } from "./IconOffsideMis.vue?vue&type=template&id=1813154d&ts=true"
import script from "./IconOffsideMis.vue?vue&type=script&lang=ts"
export * from "./IconOffsideMis.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__